define.alias("ember-math-helpers/helpers/ceil", "preview-grid/helpers/ceil");